import { IconBack01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** onClick */
  onClick?: () => void;
}

const ModalBackBtn = ({ onClick }: IProps) => (
  <S.ModalBackBtn
    className="modal-back-btn"
    label="뒤로"
    icon={<IconBack01 />}
    onClick={onClick}
  />
);

export default ModalBackBtn;
